'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'thumbtack';
var width = 384;
var height = 512;
var aliases = [128204,128392,"thumb-tack"];
var unicode = 'f08d';
var svgPathData = ['M32 312l0 8 144 0 0-96 0-16 32 0 0 16 0 96 144 0 0-8c0-.5 0-.8-.1-1.1c-.1-.7-.2-1.7-.4-2.8c-.4-2.4-1.2-5.4-2.3-9c-2.2-7.2-5.7-16.1-10.7-25.6c-10.1-19.1-25.4-39.5-46.6-55L280 209.7 278.9 195 266.4 32 117.6 32 105.2 193.4l-1.2 15.1-12.4 8.7C70.6 232 55.4 251.6 45.5 270.4C35.2 290 32 306 32 312z', 'M280 209.7l11.9 8.7c21.2 15.5 36.6 35.9 46.6 55c5 9.5 8.5 18.4 10.7 25.6c1.1 3.6 1.8 6.7 2.3 9c.2 1.2 .3 2.1 .4 2.8c0 .4 .1 .6 .1 .8l0 .2c0 0 0 0 0 .1c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l0 8-144 0 0-96 0-16-32 0 0 16 0 96L32 320l0-8s0 0 0 0c0-6 3.2-22 13.5-41.6c9.9-18.9 25.1-38.5 46.2-53.3l12.4-8.7 1.2-15.1L117.6 32l148.7 0 12.5 163 1.1 14.7zM208 352l144 0 32 0 0-32 0-8c0-21.3-21.3-81.6-73.2-119.5L298.5 32 320 32l16 0 0-32L320 0 296 0 88 0 64 0 48 0l0 32 16 0 21.5 0L73.3 191C21.3 227.5 0 286.4 0 312l0 8 0 32 32 0 144 0 0 144 0 16 32 0 0-16 0-144z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbtack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;